import { useTranslation } from 'react-i18next';
import { TeContainer, TeGrid } from '@topcon/tuicl-react';

import { Section } from '../../utils/styling';
import Header from '../../components/Header';
import Card from '../../components/Card';
import { AppRoutes, useHideCustomerSuggestions } from '../../app/routes/utils';

function CustomersHub() {
  const { t } = useTranslation();
  const hideSuggestions = useHideCustomerSuggestions();

  return (
    <TeContainer column grow gap="xs" padding="xs" overflow="auto" alignItems="center">
      <Header text={t('customersHub.title')} />
      <Section>
        <TeGrid gap="s">
          <Card
            icon="handshake"
            title={t('customersHub.customers.title')}
            description={t('customersHub.customers.description')}
            buttonText={t('customersHub.customers.buttonText')}
            route={{ to: AppRoutes.CustomersList }}
          />
          <Card
            icon="drafts"
            title={t('customersHub.invites.title')}
            description={t('customersHub.invites.description')}
            buttonText={t('customersHub.invites.buttonText')}
            route={{ to: AppRoutes.CustomerInvites }}
          />
          <Card
            icon="concierge"
            title={t('customersHub.requests.title')}
            description={t('customersHub.requests.description')}
            buttonText={t('customersHub.requests.buttonText')}
            route={{ to: AppRoutes.CustomerRequests }}
          />
          {!hideSuggestions && (
            <Card
              icon="auto_awesome"
              title={t('customersHub.suggestions.title')}
              description={t('customersHub.suggestions.description')}
              buttonText={t('customersHub.suggestions.buttonText')}
              route={{ to: AppRoutes.CustomerSuggestions }}
            />
          )}
        </TeGrid>
      </Section>
    </TeContainer>
  );
}

export default CustomersHub;
